
import { makeAutoObservable } from 'mobx';

interface TeacherType{
    id_teacher: number;
    s_t_fio: string;
    t_fio: string;
    post: string
} 


class Teacher {
    teachers: TeacherType[] = []
    teacher: TeacherType = {
        id_teacher: 0,
        s_t_fio: "",
        t_fio: "",
        post: "",
    }

    constructor(){
        makeAutoObservable(this)
    }

    newTeachers(param: TeacherType[]){
        this.teachers = param;
    }

    newTeacher(param: TeacherType){
        this.teacher = param;
    }
}

export const teacher = new Teacher()